"use strict";

import _ from "lodash";

import AppConstants from "../constants/AppConstants";
import BaseLayoutTransformer from "./BaseLayoutTransformer";

import BlockLayout from "./BlockLayout";
import ElementPropertyCopier from "./ElementPropertyCopier";
import BlockPropertyCopier from "./BlockPropertyCopier";

import BackgroundElementFilter from "./BackgroundElementFilter";
import NearByElementGroupingStrategy from "./NearbyElementGroupingStrategy";
import SingleElementGroupingStrategy from "./SingleElementGroupingStrategy";
import SingleGroupGroupStrategy from "./SingleGroupGroupingStrategy";

import MobileGroupAutoLayoutStrategy from "./MobileGroupAutoLayoutStrategy";
import DesktopScaleLayoutStrategy from "./DesktopScaleLayoutStrategy";
import StackLayoutStrategy from "./StackLayoutStrategy";

import MobileBlockLayoutManager from "./MobileBlockLayoutManager";

class DesktopToMobileTransformer extends BaseLayoutTransformer {
  constructor(/** Object **/ block, /** Object **/ config) {
    super(block, config);
  }

  transform() {
    //TODO Look at handling Site Canvas and Canvases using Site Canvases

    let desktopLayout = _.get(this.block, AppConstants.LAYOUT_DESKTOP);

    let layoutType = _.get(this.config, "layout", "auto");
    let groupStrategy = null;
    let layoutStrategy = null;

    switch (layoutType) {
      case "auto":
        groupStrategy = new NearByElementGroupingStrategy();
        layoutStrategy = new MobileGroupAutoLayoutStrategy();
        break;
      case "scale":
        groupStrategy = new SingleGroupGroupStrategy();
        layoutStrategy = new DesktopScaleLayoutStrategy({
          initialHeight: _.get(desktopLayout, "h"),
        });
        break;
      case "stack":
        groupStrategy = new SingleElementGroupingStrategy();
        layoutStrategy = new StackLayoutStrategy();
        break;
    }

    let elementPropCopier = new ElementPropertyCopier(
      AppConstants.LAYOUT_DESKTOP,
      AppConstants.LAYOUT_MOBILE
    );

    let backgroundRect = this._getLayoutRect(AppConstants.LAYOUT_DESKTOP);
    let backgroundElementFilter = new BackgroundElementFilter(backgroundRect);

    let layoutManager = new MobileBlockLayoutManager();
    layoutManager.setGroupLayoutStrategy(layoutStrategy);

    //multiple block layouts due to canvas views;
    let blockLayouts = [];

    let blockLayout = this._layout(
      this.block,
      groupStrategy,
      backgroundElementFilter,
      layoutManager,
      elementPropCopier
    );

    blockLayouts.push(blockLayout);

    let states = _.get(this.block, "states", []);

    for (let i = 0; i < states.length; i++) {
      blockLayout = this._layout(
        states[i],
        groupStrategy,
        backgroundElementFilter,
        layoutManager,
        elementPropCopier
      );
      blockLayouts.push(blockLayout);
    }

    this._finalize(blockLayouts, layoutType);

    return this.block;
  }

  _layout(
    /** Object **/ elementContainer,
    groupStrategy,
    backgroundFilter,
    layoutManager,
    elementPropCopier
  ) {
    let elements = _.get(elementContainer, "elements", false);
    let elementData = this._gatherElementData(elements, AppConstants.LAYOUT_DESKTOP);
    let blockLayout = new BlockLayout(elementData);

    if (groupStrategy != null) {
      blockLayout.setBackgroundFilter(backgroundFilter);
      blockLayout.setElementGroupStrategy(groupStrategy);

      blockLayout.groupElements();

      layoutManager.layout(blockLayout);
    }

    let copyElementProps = _.get(this.config, "copyElementProps", true);

    if (copyElementProps) {
      _.map(elements, function (element) {
        return elementPropCopier.copy(element);
      });
    }

    return blockLayout;
  }

  _finalize(/** Array **/ blockLayouts, /** String **/ layoutType) {
    let desktopLayout = _.get(this.block, AppConstants.LAYOUT_DESKTOP);
    let mobileLayout = _.get(this.block, AppConstants.LAYOUT_MOBILE);
    let desktopHeight = _.get(desktopLayout, "h");

    if ("none" != layoutType) {
      //handle 1px special case
      if (desktopHeight == 1) {
        mobileLayout.h = desktopHeight;
      } else {
        mobileLayout.h = _.maxBy(blockLayouts, function (o) {
          return o.height;
        }).height;

        if (mobileLayout.h <= 0) {
          mobileLayout.h = desktopHeight;
        }
      }
    }

    let copyBlockProps = _.get(this.config, "copyBlockProps", true);

    if (copyBlockProps) {
      let blockPropCopier = new BlockPropertyCopier(
        AppConstants.LAYOUT_DESKTOP,
        AppConstants.LAYOUT_MOBILE
      );
      this.block = blockPropCopier.copy(this.block, { includeStates: true });
    }
  }
}

export default DesktopToMobileTransformer;
